import IconArrow from "../../../public/images/arrow-down-mini.svg";
import PropTypes from "prop-types";

const ArrowButtonInput = ({isBottom, onClick}) => {
  return (
    <button className={`select__input-button ${isBottom ? 'select__input-button-bottom' : 'select__input-button-top'}`}
            onClick={(event) => {
              event.stopPropagation();
              return onClick()
            }}>
      <IconArrow className={`select__input-arrow ${!isBottom && 'select__input-arrow-top'}`}/>
    </button>
  )
}

ArrowButtonInput.propTypes = {
  isBottom: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ArrowButtonInput;
